import axiosInstance from 'helpers/axiosInstance';

export interface GetReferrerResponse {
  referringPcpName: string;
}

export const getReferrer = async (memberId: string) => {
  const url = `/patients/patients/${memberId}/referring_pcp_name`;

  return axiosInstance
    .get<GetReferrerResponse>(url)
    .then(r => r.data.referringPcpName);
};
